import { connect } from 'react-redux';
import queryString from 'qs';
import { get, defaultsDeep, isNull } from 'lodash';
import TabbedFilters from './TabbedFilters';
import {
  selectGroupings,
  selectFields,
  selectCategories
} from '../../../reducers/filters-reducer';
import {
  clearFilter,
  clearTabbedFilters,
  updateFilters,
  updateFilterOptions,
  resetFilters
} from '../../../actions/filters-actions';
import { openAudienceSegmentWindow } from '../../../actions/audience-segment-actions';
import {
  defaultStateForMapStateToProps,
  defaultActionsForMapDispatchToProps
} from '../../../utils/redux';
import { selectAllowedPages } from '../../../reducers/user-reducer';
import { removeNulls } from '../../../utils/filters';

const getRestrictedCategories = (allowedPages = []) => {
  const restrictedCategories = [];
  const allowedMovies = allowedPages.includes('/movies');
  const allowedShows = allowedPages.includes('/shows');
  if (!allowedMovies) {
    restrictedCategories.push('movie');
  }

  if (!allowedShows) {
    restrictedCategories.push('show');
  }
  return restrictedCategories;
};

const mapStateToProps = (state, { labelFields } ) => {
  const query = get(state, 'router.location.search', '').slice(1);
  const segmentUUid = get(queryString.parse(query), 'segment', null);
  const segments = get(state, 'filters.fields.segments.options', []);
  const restrictedCategories = getRestrictedCategories(
    selectAllowedPages(state)
  );
  const mapStateToPropsWithDefaults = defaultStateForMapStateToProps({
    fields: selectFields,
    groupings: selectGroupings,
    allowedDataCategories: selectCategories,
    restrictedCategories,
    segmentUUid,
    segments
  });
  return (state, ownProps) => {
    const updatedState = mapStateToPropsWithDefaults(state, ownProps);
    const { fields } = updatedState;
    const { labelFields = {} } = ownProps;
    const fieldsWithoutNullValues = removeNulls(fields, isNull);
    const updatedFields = defaultsDeep(fieldsWithoutNullValues, labelFields);
    return { ...updatedState, ...{ fields: { ...updatedFields }}};
  }
};

const defaultActions = {
  onApply: updateFilters,
  onClear: clearFilter,
  onClearAll: clearTabbedFilters,
  onUpdateFilterOptions: updateFilterOptions,
  openAudienceSegmentWindow,
  resetFilters
};

// const mapStateToProps = defaultStateForMapStateToProps(defaultState);
const mapDispatchToProps = defaultActionsForMapDispatchToProps(defaultActions);

export default connect(mapStateToProps, mapDispatchToProps)(TabbedFilters);
